export type DecisionAssistantAnalytics = {
  da_flag_enabled: boolean
  da_shown: boolean
  da_available?: boolean
  da_outcome?: string | null
  treatment?: string | null
}

export enum PosthogEvent {
  MED_REQUEST_APPROVED = 'med_request_approved',
  MED_REQUEST_CONTACT = 'med_request_contact',
  MED_REQUEST_REJECTED = 'med_request_rejected',
  TIME_SPENT = 'time_spent',
  MED_REQUEST_VIEWED = 'med_request_viewed',
  MED_REQUEST_BATCH_APPROVED = 'med_request_batch_approved',
  MED_REQUEST_BATCH_VIEWED = 'med_request_batch_viewed'
}
